import type { JSX } from 'react';

import { CanonicalUrl } from './components/CanonicalUrl';
import { Meta } from './components/Meta';
import { Title } from './components/Title';

export function Head(): JSX.Element {
	return (
		<>
			<Title />
			<CanonicalUrl />
			<Meta />
		</>
	);
}
